// The logo supplier's (app117) availability as the API reports it
// (GET supplier-status, flag REACT_APP_SUPPLIER_STATUS_ENABLED). Read by
// the SupplierStatusBanner only; never blocks anything.
export type SupplierStatusReason = "latchOpen" | "probeFailed";

export type SupplierOp = "upload" | "clone" | "color" | "method" | "resize";

export const SUPPLIER_OPS: readonly SupplierOp[] = [
  "upload",
  "clone",
  "color",
  "method",
  "resize",
];

export interface SupplierStatus {
  ok: boolean;
  degraded: boolean;
  reason: SupplierStatusReason | null;
  // When the current state began (the latch opened / the probe failed);
  // null when ok or unknown.
  since: Date | null;
  retryAfterSeconds: number;
  affected: SupplierOp[];
  lastProbeUtc: Date | null;
  lastProbeOk: boolean | null;
  checkedUtc: Date;
  // True when the route answered 404 (the API's flag is off / the route is
  // not deployed): a silent "ok" - the banner never shows and the status is
  // not read again in this session.
  routeMissing: boolean;
}
